import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/forkJoin';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import { AppConfigService } from '../../services/app-config.service';


@Injectable()
export class AttachmentService {

  private listPiecesJointes = new BehaviorSubject<string[]>(null);
  public listPiecesJointes$ = this.listPiecesJointes.asObservable();

  constructor(
    private httpClient: HttpClient
  ) { }

  /**
   * Webservice lançant la suppresion d'une pièce jointe grâce à son id et à l'id du formulaire auquel elle est associée
   *
   * @param idFile
   * @param idCerfa
   * @returns {Observable<any>}
   */
  deleteFiles(idFile, idCerfa) {
    const url = AppConfigService.settings.urlServeur + 'rest/form/file/delete/?idCerfa=' + idCerfa + '&idFile=' + idFile;
    return this.httpClient.get(url)
      .catch((error: any) => Observable.throw(error.error || 'Server error'));
  }

  /**
   * Webservice d'envoi des pièces jointes
   *
   * @param body
   * @returns {Observable<boolean>}
   */
  sendFile(file, idCerfa, rubrique?: string): Observable<boolean> {
    const body = new FormData();

    body.append('file', file);
    body.append('idCerfa', idCerfa);
    // Préfixer le nom du fichier avec la rubrique pour permettre le filtrage par rubrique
    const extractFileName = rubrique ? '[' + rubrique + ']' + file.name : file.name;
    body.append('extractFileName', extractFileName);

    const url = AppConfigService.settings.urlServeur + 'rest/form/file/upload/';
    return this.httpClient.post(url, body).map(res => res as boolean);
  }

  /**
   * Webservice récupérant toute les pièces jointes liées au formulaire identifié par l'idCerfa passée en paramètre
   *
   * @param idCerfa
   * @returns {Observable<any>}
   */
  getFiles(idCerfa) {
    const url = AppConfigService.settings.urlServeur + 'rest/form/file/?idCerfa=' + idCerfa;
    return this.httpClient.get(url)
      .catch((error: any) => Observable.throw(error.error || 'Server error'));
  }

  /**
   * Retourne, en fonction du paramètre type le header à utiliser pour la requête http
   *
   * @param {any} type
   * @returns {HttpHeaders}
   */
  createAuthorizationHeader(type = null): HttpHeaders {
    switch (type) {
      case 'json':
        return new HttpHeaders({ 'Content-Type': 'application/json' });
      case 'form-data':
        return new HttpHeaders({ 'Content-Type': 'multipart/form-data' });
      default:
        return new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    }
  }

  setListPiecesJointes(listPiecesJointes: string[]) {
    this.listPiecesJointes.next(listPiecesJointes);
  }

  /**
   * Supprime toutes les pièces jointes associées à un CERFA.
   * Récupère la liste des fichiers puis les supprime un par un.
   *
   * @param idCerfa Identifiant du CERFA
   * @returns {Observable<any>}
   */
  deleteAllFiles(idCerfa: string): Observable<any> {
    return this.getFiles(idCerfa)
      .flatMap((files: any[]) => {
        if (!files || files.length === 0) {
          return Observable.of(null);
        }
        const deleteObservables = files.map(file => this.deleteFiles(file.id, idCerfa));
        return Observable.forkJoin(deleteObservables);
      })
      .map(() => {
        this.setListPiecesJointes([]);
        return null;
      })
      .catch((error: any) => {
        console.warn('AttachmentService: erreur lors de la suppression de toutes les pièces jointes', error);
        return Observable.of(null);
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/attachment.service.ts